const b64EncodeUnicode = str => {
  return window.btoa(
    window.encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );
};

export const languageSwitcher = currentLanguage => {
  if (currentLanguage === 'en') {
    localStorage.setItem('__ods_app_locale__', b64EncodeUnicode('en_GB'));
  } else {
    if (currentLanguage) {
      localStorage.removeItem('__ods_app_locale__');
    }
  }
};
